// extracted by mini-css-extract-plugin
module.exports = {"skeletonText":"product-ui-skeleton-text_skeletonText__U3_IB","onColor":"product-ui-skeleton-text_onColor__tqnJD","striken":"product-ui-skeleton-text_striken__GaA8H"};